import {Pipe, PipeTransform} from '@angular/core';
import {SubtitlesService} from "../core";

const NO_VALUE = '- -';

@Pipe({
    name: 'format'
})
export class FormatPipe implements PipeTransform {
    constructor(
        private subtitles: SubtitlesService
    ) {
    }

    transform(value: string | number | undefined, type: number, sub?: number,
              jump?: number): string | number {
        if (type === 6 && typeof value === 'number' && value < -1000) {
            return NO_VALUE;
        }

        let unit = '';
        let subtit = sub ? sub === 1035 ? '°' : this.subtitles.setSubtitle(sub) : '';

        function double(val: number) {
            return val >= 0 && val < 100 ? ('0' + val).slice(-2) : val;
        }

        if (jump && typeof value === 'number') {
            value = value - value % jump;
        }

        switch (type) {
            case -1: // Wartosc niewidoczna
                value = '';
                break;
            case 0: // Zwyczajna wartość
                value += subtit === '°' ? '°' : ' ' + subtit;
                break;
            case 1: // Sekundy
                unit = this.subtitles.setSubtitle(685);
                value += ' ' + unit + ' ' + subtit;
                break;
            case 2: // Minuty
                unit = this.subtitles.setSubtitle(414);
                value += ' ' + unit + ' ' + subtit;
                break;
            case 3: // Godziny
                unit = this.subtitles.setSubtitle(283);
                value += ' ' + unit + ' ' + subtit;
                break;
            case 4: // Wartosc dziesietna
            case 38: // Wartosc współczynnika COP z częścią dziesiętną
                if (typeof value === 'string') {
                    value = parseInt(value);
                }
                value *= 0.1;
                value = (Math.round(value * 100) / 100).toFixed(1);
                value += subtit === '°' ? '°' : ' ' + subtit;
                break;
            case 5: // Wartosc setna
                if (typeof value === 'string') {
                    value = parseInt(value);
                }
                value *= 0.01;
                value = (Math.round(value * 100) / 100).toFixed(2);
                value += subtit === '°' ? '°' : ' ' + subtit;
                break;
            case 6: // Stopenie Celsjusza
                value += '°' + subtit;
                break;
            case 7: // Dziesiate stopnie Celsjusza
                if (typeof value === 'string') {
                    value = parseInt(value);
                }
                if (value <= -2000) {
                    value = NO_VALUE;
                } else {
                    value *= 0.1;
                    value = (Math.round(value * 100) / 100).toFixed(1);
                    value += '°' + subtit;
                }
                break;
            case 8: // Procenty
                value += '%' + subtit;
                break;
            case 9: // Promile
                value += '‰' + subtit;
                break;
            case 10: // kW
                unit = this.subtitles.setSubtitle(1908);
                value += ' ' + unit + ' ' + ' ' + subtit;
                break;
            case 11: // kWh
                unit = this.subtitles.setSubtitle(1909);
                value += ' ' + unit + ' ' + ' ' + subtit;
                break;
            case 12: // wolty
                value += 'V ' + ' ' + subtit;
                break;
            case 13: { // Czas w min zapisany w formacie 00:00 - 23:59
                if (typeof value === 'string') {
                    value = parseInt(value);
                }
                const min = value % 60;
                const hour = (value - min) / 60;
                value = double(Math.floor(hour)) + ':' + double(min) + ' ' + subtit;
                break;
            }
            case 14: // Dni
                unit = this.subtitles.setSubtitle(1906);
                value += ' ' + unit + ' ' + subtit;
                break;
            case 15: //Bieg
                unit = this.subtitles.setSubtitle(76);
                value += ' ' + unit + ' ' + subtit;
                break;
            case 16: { //Czas w sekundach (XX min XX sek)
                if (typeof value === 'string') {
                    value = parseInt(value);
                }

                const min = value % 60;
                const hour = (value - min) / 60;
                value = (hour > 0
                    ? double(Math.floor(hour)) + ' ' + this.subtitles.setSubtitle(1907) + ' '
                    : '') + double(min) + ' ' + this.subtitles.setSubtitle(1904) + ' ' + subtit;

                break;
            }
            case 17: {//Czas w minutach (XX godz XX min)
                if (typeof value === 'string') {
                    value = parseInt(value);
                }

                const min = value % 60;
                const hour = (value - min) / 60;
                value = (hour > 0
                    ? double(Math.round(hour)) + ' ' + this.subtitles.setSubtitle(1905) + ' '
                    : '') + double(min) + ' ' + this.subtitles.setSubtitle(1907) + ' ' + subtit;
                break;
            }
            case 18: { //Napis z bazy
                if (typeof value === 'string') {
                    value = parseInt(value);
                }
                let text = this.subtitles.setSubtitle(value);
                value = text === undefined ? "&#8203;" : text
                break;
            }
            case 19: { // kWh z czescia dziesietna
                if (typeof value === 'string') {
                    value = parseInt(value);
                }
                value *= 0.1;
                value = (Math.round(value * 100) / 100).toFixed(1);
                unit = this.subtitles.setSubtitle(1909);
                value += ' ' + unit + ' ' + subtit;
                break;
            }
            case 20: // MWh
                unit = this.subtitles.setSubtitle(2927);
                value += ' ' + unit + ' ' + subtit;
                break;
            case 21: {// MWh z czescia dziesietna
                if (typeof value === 'string') {
                    value = parseInt(value);
                }
                value *= 0.1;
                value = value.toFixed(1);
                unit = this.subtitles.setSubtitle(2927);
                value += ' ' + unit + ' ' + subtit;
                break;
            }
            case 22: { // l/min z czescia dziesietna
                if (typeof value === 'string') {
                    value = parseInt(value);
                }
                value *= 0.1;
                value = (Math.round(value * 100) / 100).toFixed(1);
                unit = this.subtitles.setSubtitle(2485);
                value += ' ' + unit + ' ' + subtit;
                break;
            }
            case 23: { // bar (cisnienie) z czescia dziesietna
                if (typeof value === 'string') {
                    value = parseInt(value);
                }
                if (typeof value === 'number' && value <= -2000) {
                    value = NO_VALUE;
                } else {
                    value *= 0.1;
                    value = (Math.round(value * 100) / 100).toFixed(1);
                    unit = this.subtitles.setSubtitle(2928);
                    value += ' ' + unit + ' ' + subtit;
                }
                break;
            }
            case 24: {
                // pkt czasu (ux'owy epoch)
                if (typeof value === 'string') {
                    value = parseInt(value);
                }
                const time = new Date(value * 1000);
                const year = time.getUTCFullYear();
                const month = time.getUTCMonth() + 1;
                const day = time.getUTCDate();
                const hour = time.getUTCHours();
                const min = time.getUTCMinutes();
                const sec = time.getUTCSeconds();
                value = double(day) + '-' + double(month) + '-' + year + ' '
                    + double(hour) + ':' + double(min) + ':' + double(sec) + subtit;
                break;
            }
            case 25: { // Czas w sekundach (XX dni, XX godz, XX min, XX sek)
                if (typeof value === 'string') {
                    value = parseInt(value);
                }
                const day = parseInt((value / 86400).toString()) > 0
                    ? parseInt((value / 86400).toString()) + ' ' + this.subtitles.setSubtitle(1906) + ' '
                    : '';
                const hour = (parseInt((value / 3600).toString()) % 24) > 0
                    ? (parseInt((value / 3600).toString()) % 24) + ' ' + this.subtitles.setSubtitle(1905) + ' '
                    : '';
                const min = (parseInt((value / 60).toString()) % 60) > 0
                    ? (parseInt((value / 60).toString()) % 60) + ' ' + this.subtitles.setSubtitle(1907) + ' '
                    : '';
                const sec = (value % 60) + ' ' + this.subtitles.setSubtitle(1904);

                value = day + hour + min + sec;
                break;
            }
            case 26: { // kW z czescia dziesietna
                if (typeof value === 'string') {
                    value = parseInt(value);
                }
                value *= 0.1;
                value = value.toFixed(1);
                unit = this.subtitles.setSubtitle(1908);
                value += ' ' + unit + ' ' + subtit;
                break;
            }
            case 27: // RPM
                unit = this.subtitles.setSubtitle(3206);
                value += ' ' + unit + ' ' + subtit;
                break;
            case 28: //Włączony/Wyłączony ( 1/0 )
                value = parseInt(value.toString()) === 1 ? this.subtitles.setSubtitle(1447) : this.subtitles.setSubtitle(924);
                break;
            case 29: // Wat
                unit = this.subtitles.setSubtitle(1284);
                value += ' ' + unit + ' ' + subtit;
                break;
            case 30: { // l/godz.
                if (typeof value === 'string') {
                    value = parseInt(value);
                }
                value *= 0.1;
                value = (Math.round(value * 100) / 100).toFixed(1);
                unit = this.subtitles.setSubtitle(3506);
                value += ' ' + unit + ' ' + subtit;
                break;
            }
            case 31: { // Czas w godzinach zapisany jako XX dni XX godz.
                if (typeof value === 'string') {
                    value = parseInt(value);
                }
                const hour = value % 60;
                const day = (value - hour) / 60;
                value = (day > 0 ? double(Math.round(day)) + ' ' + this.subtitles.setSubtitle(1906) + ' ' : '') + double(hour) + ' ' + this.subtitles.setSubtitle(1905) + ' ' + subtit;
                break;
            }
            case 32: // Kelwin
                value += ' K' + ' ' + subtit;
                break;
            case 33: { // % z czescia dziesietna
                if (typeof value === 'string') {
                    value = parseInt(value);
                }
                value *= 0.1;
                value = value.toFixed(1);
                value += '%' + subtit;
                break;
            }
            case 34: // Wh (wato godzina)
                unit = this.subtitles.setSubtitle(4212);
                value += ' ' + unit + ' ' + subtit;
                break;
            case 35: // Wartość w hex (0-F)
                value = value.toString(16);
                break;
            case 36: { // kWh z czescia setną
                if (typeof value === 'string') {
                    value = parseInt(value);
                }
                value *= 0.01;
                value = (Math.round(value * 100) / 100).toFixed(2);
                unit = this.subtitles.setSubtitle(1909);
                value += ' ' + unit + ' ' + subtit;
                break;
            }
            case 37: { // XX lat XX dni
                if (typeof value === 'string') {
                    value = parseInt(value);
                }
                const day = value % 365;
                const year = (value - day) / 365;
                const daySubtitle = day === 1 ? this.subtitles.setSubtitle(259) : this.subtitles.setSubtitle(1906);
                const yearSubtitle = year === 1
                    ? this.subtitles.setSubtitle(665)
                    : year < 5
                        ? this.subtitles.setSubtitle(4776)
                        : this.subtitles.setSubtitle(4752);
                value = (year > 0 ? (Math.floor(year) + ' ' + yearSubtitle) : '') + ' ' + day + ' ' + daySubtitle;
                break;
            }
            case 39: // l/m
                unit = this.subtitles.setSubtitle(3506);
                value += ' ' + unit + ' ' + subtit;
                break;
            case 40: { // kWh z częścią tysięczną
                if (typeof value === 'string') {
                    value = parseInt(value);
                }
                value *= 0.001;
                value = (Math.round(value * 1000) / 1000).toFixed(3);
                unit = this.subtitles.setSubtitle(1909);
                value += ' ' + unit + ' ' + ' ' + subtit;
                break;
            }
            case 41: // litry
                unit = this.subtitles.setSubtitle(8291);
                value += ' ' + unit + ' ' + ' ' + subtit;
                break;
            case 42: // metry sześcienne
                unit = this.subtitles.setSubtitle(8292);
                value += ' ' + unit + ' ' + ' ' + subtit;
                break;
            case 43: { // K (Kelwin) z częścią dziesiętną
                if (typeof value === 'string') {
                    value = parseInt(value);
                }
                value *= 0.1;
                value = (Math.round(value * 100) / 100).toFixed(1);
                value += ' K ' + subtit;
                break;
            }
            case 44: // mm
                value += ' mm ' + subtit;
                break;
            case 45: { // bajty z częścią dziesiętną
                if (typeof value === 'string') {
                    value = parseInt(value);
                }
                value *= 0.1;
                value = (Math.round(value * 100) / 100).toFixed(1);
                value += ' B ' + subtit;
                break;
            }
            case 46: { // kilobajty z częścią dziesiętną
                if (typeof value === 'string') {
                    value = parseInt(value);
                }
                value *= 0.1;
                value = (Math.round(value * 100) / 100).toFixed(1);
                value += ' kB ' + subtit;
                break;
            }
            case 47: { // megabajty z częścią dziesiętną
                if (typeof value === 'string') {
                    value = parseInt(value);
                }
                value *= 0.1;
                value = (Math.round(value * 100) / 100).toFixed(1);
                value += ' MB ' + subtit;
                break;
            }
            case 48: { // gigabajty z częścią dziesiętną
                if (typeof value === 'string') {
                    value = parseInt(value);
                }
                value *= 0.1;
                value = (Math.round(value * 100) / 100).toFixed(1);
                value += ' GB ' + subtit;
                break;
            }
            case 49: { // terabajty z częścią dziesiętną
                if (typeof value === 'string') {
                    value = parseInt(value);
                }
                value *= 0.1;
                value = (Math.round(value * 100) / 100).toFixed(1);
                value += ' TB ' + subtit;
                break;
            }
        }

        return value;
    }
}
